import { create } from 'zustand'

// Tiny store for the "client outdated" blocking state. Set by api/client.ts
// on any HTTP 426 and by api/ws.ts on a WS close with code 4426. Once set
// the UI renders a blocking modal — there is no clear path; the user must
// update the app.
//
// Spec: docs/forward-compat-version-handshake.md.

export type OutdatedInfo = {
  minVersion: string
  yourVersion: string
  updateURL?: string
}

type State = {
  outdated: OutdatedInfo | null
  setOutdated: (info: OutdatedInfo) => void
}

export const useOutdatedStore = create<State>((set) => ({
  outdated: null,
  setOutdated: (info) => set({ outdated: info }),
}))

export function markOutdated(info: OutdatedInfo) {
  useOutdatedStore.getState().setOutdated(info)
}
